import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { colorScheme } from 'src/app/shared/constants/static-variable';
import { PricePipe } from 'src/app/shared/pipe/price.pipe';

@Component({
  selector: 'app-micro-product-detail-page',
  templateUrl: './micro-product-detail-page.component.html',
  styleUrls: ['./micro-product-detail-page.component.scss'],
})
export class MicroProductDetailPageComponent implements OnInit, OnChanges {
  @Input() industryReport: any;

  colorScheme2 = colorScheme;
  gradient = false;
  showXAxis = true;
  showYAxis = true;
  showYAxisLabel = true;
  showLegend = true;
  showXAxisLabel = true;
  fundingChartData: any[] = [];
  colorScheme3 = {
    domain: [
      '#0066FF',
      '#111111',
      '#1F78B4',
      '#0C87F9',
      '#1a1aff',
      '#1aa3ff',
      ' #3366ff',
      ' #4db8ff',
      '#0000e6',
      '#4da6ff',
    ],
  };
  maxLabelLength = 20;

  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges() {
    // console.log(this.industryReport);
    this.industryReport?.deliverables?.forEach((chartData) => {
      return chartData.chartData = this.convertChartData(
        chartData.chartData
      );
    });
  }

  valueFormatting(value) {
    const filterPipe = new PricePipe();
    return filterPipe.transform(value, null, true);
  }

  convertChartData(chartData) {
    const result = [];
    let hiddenValue = 0;
    const hiddenNames = [];

    chartData.forEach((item) => {
      if (item.show) {
        result.push({ name: item.label, value: parseInt(item.value) });
      } else {
        hiddenValue += parseInt(item.value);
        hiddenNames.push(item.label);
      }
    });

    if (hiddenValue > 0) {
      result.push({
        name: `hidden`,
        value: hiddenValue,
      });
    }
    return result;
  }
}
